import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import Header from "components/headers/dark.js";
import Footer from "components/footers/SimpleFiveColumn";
import TeamCard from "../components/cards/AdvisorsProfile";
import { AssociatesSection } from "./Associates";
import { AdvisorsSection } from "./Advisors";
import SmitaImage from "../images/Team/1-Smitha Puthucheri.jpg";
import AshwiniImage from "../images/Team/2-Ashwini Pai.jpg";
import JyotsanaImage from "../images/Team/3-Jyotsna.jpg";
import RajagopalImage from "../images/Team/5-Rajagopal Subrahmanian.jpg";
import KiranImage from "../images/Team/7-Kiran Mohan Das.jpg";
import AnanthuImage from "../images/Team/8-Ananthu C N.jpg";
import RanjeeshImage from "../images/Team/9 - Ranjeesh.jpg";
import SavitriImage from "../images/Team/10-Savitri Devi Singh.jpg";
import GeethanjaliImage from "../images/Team/13-Geethanjali P.jpg";

import { ReactComponent as TwitterIcon } from "../images/twitter-icon.svg";
import { ReactComponent as LinkedinIcon } from "../images/linkedin-icon.svg";

import OurPartners from "components/cards/OurPartners";

// CSS styling to center the cards
const PageWrapper = tw.div`my-6 md:m-10`;
const Subheading = tw.span`uppercase tracking-wider text-sm`;
// Change this line - remove the grid since it's now in the CardComponent
const CardsContainer = tw.div`w-full`;
const PageHeading = tw.h1`text-4xl sm:text-5xl font-black tracking-wide text-center mt-5`;
const SectionHeading = tw.h2`text-2xl sm:text-3xl font-bold tracking-wide text-center text-primary-500 mt-8`;
const cards = [
  {
    imageSrc: SmitaImage,
    position: "Founder & Director",
    name: "Dr. Smitha Puthucheri",
    smallDescription: `
      Registered Patent Agent<br />
      PhD in Materials Chemistry - Indian Institute of Technology Kanpur<br />
      Ex-Senior Project Coordinator at Technology Development Board (Department of Science & Technology) GOI.
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Dr. Smitha Puthucheri</h1>
      <li><b>Background:</b> PhD in Materials Chemistry from IIT Kanpur, with extensive government experience at Technology Development Board and TIFAC under Department of Science & Technology</li>
      <li><b>Research & Development:</b> 20 years of experience in Chemistry/Materials Chemistry/DRDO projects, author of 40+ scientific publications in national/international journals and holder of 2 granted patents</li>
      <li><b>Industrial Experience:</b> 5 years in Industrial Project Management and 7 years in Patent-related works and Patent Law Firm operations</li>
      <li><b>Additional Expertise:</b> 3 years in manuscript editing services, combining technical writing with patent prosecution experience</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: AshwiniImage,
    position: "Manager-IPR",
    name: "Mrs. P. Ashwini Pai",
    smallDescription: `
      Registered Patent Agent<br />
      M. Pharm (Pharmaceutics) - Qualified GPAT<br />
      Ex-Incharge of Innovation and Incubation Center at Nitte College of Pharmaceutical Sciences, Bengaluru
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Mrs. P. Ashwini Pai</h1>
      <li><b>Educational Background:</b> M. Pharm (Pharmaceutics) with GPAT qualification, specializing in pharmaceutical sciences</li>
      <li><b>Academic Leadership:</b> Former In-charge of Innovation and Incubation Center and Assistant Professor at Nitte College of Pharmaceutical Sciences, Bengaluru</li>
      <li><b>Government Experience:</b> Ex-Project Manager for Student Startup & Innovation Policy (SSIP) Cell at Gujarat Knowledge Society, Gandhinagar</li>
      <li><b>Patent Training:</b> Completed Patent Training at Technology Information Forecasting and Assessment Council (Department of Science & Technology) GOI</li>
      <li><b>Professional Experience:</b> 7 years in IPR Management and 5 years in Research and Development, with specialized focus on startup patent strategies</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: JyotsanaImage,
    position: "Senior IPR Attorney",
    degree: "Life Sciences",
    name: "Mrs. Jyotsana Dhasmana",
    smallDescription: `
      Registered Patent Agent<br />
      B.Tech in Biotechnology, Masters in Food Technology<br />
      Currently pursuing LLB
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Mrs. Jyotsana Dhasmana</h1>
      <li><b>Educational Background:</b> B.Tech in Biotechnology and Masters in Food Technology, currently pursuing LLB to strengthen legal expertise</li>
      <li><b>Patent Law Firm Experience:</b> 7 years of comprehensive experience working with Patent Law firms</li>
      <li><b>Patent Prosecution:</b> 5 years of specialized experience in Patent Prosecution procedures and processes</li>
      <li><b>International Patent Experience:</b> Extensive experience in handling USPTO (United States) and German Patent applications and procedures</li>
      <li><b>Government Training:</b> Completed Patent Training at Technology Information Forecasting and Assessment Council (Department of Science & Technology) GOI</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: RajagopalImage,
    position: "Senior IPR Associate",
    degree: "Mechanical Engineering",
    name: "Dr. Rajagopal Subrahmaniam",
    smallDescription: `
      BE- Mechanical Engineering, PhD from University of Stuttgart - Germany<br />
      MBA holder in Technology Management<br />
      Freelance consultant for ISO certification
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Dr. Rajagopal Subrahmaniam</h1>
      <li><b>Educational Background:</b> BE in Mechanical Engineering and PhD from University of Stuttgart, Germany, with MBA in Technology Management</li>
      <li><b>Research Experience:</b> 20 years of comprehensive experience in Research & Development in engineering and technology domains</li>
      <li><b>IPR Management:</b> 7 years of specialized experience in Intellectual Property Rights Management</li>
      <li><b>Patent Engineering:</b> Former Patent Engineer with private firm in Chennai, bringing practical patent application experience</li>
      <li><b>Quality Management:</b> Freelance consultant for ISO certification, combining technical expertise with quality management systems</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: SavitriImage,
    position: "Patent Associate",
    degree: "Computer Science",
    name: "Mrs. Savitri Devi Singh",
    smallDescription: `
      Post Graduate in Computer Science<br />
      More than 5 years in Information Technology<br />
      Expert in AI and Deep Learning projects
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Mrs. Savitri Devi Singh</h1>
      <li><b>Educational Background:</b> Post Graduate in Computer Science with strong foundation in computational theories and applications</li>
      <li><b>IT Experience:</b> More than 5 years of comprehensive expertise in Information Technology sector</li>
      <li><b>AI & Deep Learning:</b> Successfully completed projects in Artificial Intelligence and Deep Learning domains</li>
      <li><b>System Deployment:</b> Deployed intelligent systems for real-world applications and practical implementations</li>
      <li><b>Integration Expertise:</b> Proven ability to integrate AI solutions into broader IT infrastructures for seamless operations</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: RanjeeshImage,
    position: "IPR Associate",
    degree: "Electrical Engineering",
    name: "Mr. Ranjeesh Kumar",
    smallDescription: `
      Graduate in Electrical Engineering<br />
      Over 3 years in Electronic Manufacturing industry<br />
      Specializing in electronic components and systems design
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Mr. Ranjeesh Kumar</h1>
      <li><b>Educational Background:</b> Graduate in Electrical Engineering with specialized knowledge in electronic systems</li>
      <li><b>Industry Experience:</b> Over 3 years of hands-on experience in the Electronic Manufacturing industry</li>
      <li><b>Design Expertise:</b> Specializing in the design, development, and support of electronic components and systems</li>
      <li><b>Technical Skills:</b> Proven expertise in ECAD (Electronic Computer-Aided Design) tools for circuit design and layout</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: GeethanjaliImage,
    position: "Paralegal",
    name: "Adv. Geethanjali P.",
    smallDescription: `
      B.B.A. LL.B. (Hons.)<br />
      Enrolled Advocate and AIBE Qualified<br />
      LL.M. in Intellectual Property Rights
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Adv. Geethanjali P.</h1>
      <li><b>Educational Background:</b> B.B.A. LL.B. (Hons.)</li>
      <li><b>Legal Qualification:</b> Enrolled Advocate and AIBE Qualified.</li>
      <li><b>IPR Specialization:</b> LL.M. in Intellectual Property Rights, with a focus on intellectual property law.</li>
      <li><b>Professional Experience:</b> Practiced as an Advocate before the District Courts in Kerala, gaining practical experience in legal research, case analysis, drafting, and court proceedings.</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: KiranImage,
    position: "Accounts Manager",
    name: "Mr. Kiran M",
    smallDescription: `
      Bachelor's Degree in Commerce<br />
      7 years of experience in Accounts Management<br />
      Financial operations and management specialist
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Mr. Kiran M</h1>
      <li><b>Educational Background:</b> Bachelor's Degree in Commerce with strong foundation in financial principles and accounting practices</li>
      <li><b>Professional Experience:</b> 7 years of comprehensive experience in Accounts Management across various business environments</li>
      <li><b>Financial Operations:</b> Expertise in managing day-to-day financial operations, bookkeeping, and financial reporting</li>
      <li><b>Account Management:</b> Skilled in client account management, financial planning, and budget preparation</li>
      <li><b>Compliance & Reporting:</b> Experience in ensuring financial compliance and preparing accurate financial reports for management decision-making</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: AnanthuImage,
    position: "Website Manager",
    name: "Mr. Ananthu C N",
    smallDescription: `
      Diploma in Animation & Multimedia<br />
      3 years of experience in Network management<br />
      Digital media and web management specialist
    `,
    bigDescription: `
    <ul>
      <h1 style="font-size: 16px; font-weight: bold; padding-bottom:10px; text-align:center;">Mr. Ananthu C N</h1>
      <li><b>Educational Background:</b> Diploma in Animation & Multimedia with expertise in digital media creation and management</li>
      <li><b>Network Management:</b> 3 years of specialized experience in Network management and IT infrastructure</li>
      <li><b>Website Management:</b> Responsible for maintaining and managing company website operations and digital presence</li>
      <li><b>Multimedia Expertise:</b> Skilled in animation, multimedia content creation, and digital asset management</li>
      <li><b>Technical Support:</b> Provides technical support for digital platforms and ensures optimal website performance and user experience</li>
    </ul>
  `,
    links: [
      {
        url: "https://twitter.com",
        icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        icon: LinkedinIcon,
      },
    ],
  },
];

const TeamCardsList = () => (
  <CardsContainer>
    <TeamCard cards={cards} heading="" description="" />
  </CardsContainer>
);

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <PageHeading>Meet the Team</PageHeading>
      <div id="team">
        <SectionHeading>Team</SectionHeading>
        <PageWrapper>
          <TeamCardsList />
        </PageWrapper>
      </div>
      <div id="associates">
        <SectionHeading>Associates</SectionHeading>
        <PageWrapper>
          <AssociatesSection />
        </PageWrapper>
      </div>
      <div id="advisors">
        <SectionHeading>Advisors</SectionHeading>
        <PageWrapper>
          <AdvisorsSection />
        </PageWrapper>
      </div>
      {/* <OurPartners /> */}

      <Footer />
    </AnimationRevealPage>
  );
};
